// extracted by mini-css-extract-plugin
export default {"main_div":"page_main_div__q2402","logo":"page_logo__t03U+","divider":"page_divider__DYCAh","active":"page_active__a721Q","title_div":"page_title_div__xmMX0"};